const AppError = () => {
    return (
        <div className="h-screen w-screen flex items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-3 text-center px-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <p className="text-black text-2xl font-bold">Something went wrong</p>
                <p className="text-gray-600 text-base">
                    Failed to load Anganwadi application. Please retry.
                </p>
            </div>
        </div>
    );
};

export default AppError;